export const Page404 = () => {
    return (
        <div></div>
    )
}